import { atom } from "recoil";

export const posCart = atom({
    key: "posCart",
    default: []
})

export const currectOrderAtom = atom({
    key: "currentOrderAtom",
    default: null
})